
import Vue from 'vue';
import Component from 'vue-class-component';
import { UserApi } from '@/api/user.api';
import { take } from 'rxjs/operators';
import { validators } from '@/utils/validations';
import { Ref } from 'vue-property-decorator';
import { VForm } from 'vuetify/lib';
import {
  UserChangePasswordModel,
  UserModel,
  UserUpdatePayload
} from '@/models/user.model';
import { userModule } from '@/utils/store-acessor';

@Component({})
export default class ProfileSecurityConfig extends Vue {
  @userModule.Getter('user') user!: UserModel;
  model = new UserUpdatePayload();
  rules = validators;
  // @ts-ignore
  @Ref() form: VForm;
  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = '';
  data: UserChangePasswordModel = { email: '' };
  loading = false;

  mounted() {
    if (this.user?.email) {
      this.data.email = this.user.email;
    }
  }

  currentPasswordRules(): (string | boolean)[] {
    const password = this.data.password || '';
    const current_password: string = this.data.current_password || '';
    const password_confirmation = this.data.password_confirmation || '';
    if (password.length > 0 || password_confirmation.length > 0) {
      return [this.rules.required(current_password)];
    }
    return [];
  }

  passwordRules(isConfirmPassword?: boolean): (string | boolean)[] {
    const password = this.data.password ? this.data.password : '';
    const password_confirmation = this.data.password_confirmation
      ? this.data.password_confirmation
      : '';
    if (password.length > 0 || password_confirmation.length > 0) {
      return [
        this.rules.min(isConfirmPassword ? password_confirmation : password, 8),
        this.rules.samePassword(password_confirmation, password)
      ];
    } else {
      return [];
    }
  }

  onChangePassword() {
    if (this.form.validate()) {
      this.loading = true;
      new UserApi()
        .changePasswordOrEmail(this.data)
        .pipe(take(1))
        .subscribe(
          () => {
            this.loading = false;
            this.snackbarVisibility = true;
            this.snackbarColor = 'green';
            this.snackbarText = 'auth.message.credentials_has_updated';
          },
          () => {
            this.loading = false;
            this.snackbarVisibility = true;
            this.snackbarColor = 'red';
            this.snackbarText = 'auth.message.credentials_not_updated';
          }
        );
    }
  }
}
